/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TGetIncreaseBetsPositionsCountByAnnouncementModel,
  IGetIncreaseBetsPositionsCountByAnnouncementRequest,
  IMappers,
  IGetIncreaseBetsPositionsCountByAnnouncementResponse,
  IGetIncreaseBetsPositionsCountByAnnouncementResponseError,
  TGetIncreaseBetsPositionsCountByAnnouncementResponse
} from "./types";

const defaultConfig: TGetIncreaseBetsPositionsCountByAnnouncementModel = {
  apiType: "public",
  assertStatusCodes: [200, 400],
  method: "GET",
  microserviceName: "auction",
  pathApi: "/v2/get-increase-bets-positions-count-by-announcement/",
  hostType: "api"
} as TGetIncreaseBetsPositionsCountByAnnouncementModel;

function createGetIncreaseBetsPositionsCountByAnnouncementModel(
  parameters: IGetIncreaseBetsPositionsCountByAnnouncementRequest
): TGetIncreaseBetsPositionsCountByAnnouncementModel {
  return {
    ...defaultConfig,
    parameters
  };
}

export interface IGetIncreaseBetsPositionsCountByAnnouncementOptions<
  TResponse200,
  TResponse400
> {
  httpApi: IHttpApi;
  parameters: IGetIncreaseBetsPositionsCountByAnnouncementRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetIncreaseBetsPositionsCountByAnnouncement<
  TResponse200,
  TResponse400
>({
  httpApi,
  parameters,
  config,
  mappers
}: IGetIncreaseBetsPositionsCountByAnnouncementOptions<
  TResponse200,
  TResponse400
>): Promise<
  | TResponse200
  | TResponse400
  | TGetIncreaseBetsPositionsCountByAnnouncementResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createGetIncreaseBetsPositionsCountByAnnouncementModel(parameters),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](
        response as IGetIncreaseBetsPositionsCountByAnnouncementResponse
      );
    }

    if (statusCode === 400) {
      return mappers[400](
        response as IGetIncreaseBetsPositionsCountByAnnouncementResponseError
      );
    }
  }

  return {
    response,
    statusCode
  } as TGetIncreaseBetsPositionsCountByAnnouncementResponse;
}

export {
  defaultConfig,
  createGetIncreaseBetsPositionsCountByAnnouncementModel,
  fetchGetIncreaseBetsPositionsCountByAnnouncement
};
